import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http'
@Injectable({
  providedIn: 'root'
})
export class IndexloginService {
  baseUrl = localStorage.getItem("waldobaseAuthURL");
  constructor(private httpclient: HttpClient) { }


  public login(base_Url, params): Observable<any> {
    return this.httpclient.post(base_Url + "/api/auth/login", params);
  }
  public sendOtp(base_Url, params): Observable<any> {
    return this.httpclient.post(base_Url + "/api/auth/forgot", params);
  }
  public confirmOtp(base_Url, params): Observable<any> {
    return this.httpclient.post(base_Url + "/api/auth/otp/verify", params);
  }
  public updatePsword(base_Url, params): Observable<any> {

    return this.httpclient.get(base_Url + "/api/auth/update/password?password=" + params.password);
  }
  public getMenuList(): Observable<any> {
    console.log(this.baseUrl)
   let  baseUrl = localStorage.getItem("waldobaseAuthURL");
    return this.httpclient.get(baseUrl + "/api/menu/list?roleId=" + localStorage.getItem('waldo_roleId') + "&compId=" + localStorage.getItem('waldo_compId'));
  }
  public getRole(): Observable<any> {
    let  baseUrl = localStorage.getItem("waldobaseAuthURL");
    return this.httpclient.get(baseUrl + "/api/auth/role/list?userId=" + localStorage.getItem('WaldoUid'));
  }
  public getComp(): Observable<any> {
    let  baseUrl = localStorage.getItem("waldobaseAuthURL");
    return this.httpclient.get(baseUrl + "/api/auth/comp/list?userId=" + localStorage.getItem('WaldoUid'));
  }
  isLoggedIn(): boolean {
    const token = localStorage.getItem('waldo_apiSecret');
    if (!token) return false;
    return true;
  }
}
